import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router'; // Assuming you want to redirect

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {

    constructor(private router: Router) {} // Inject Router for navigation

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    // Handle 401 Unauthorized error
                    console.error('401 Unauthorized error intercepted:', error);
                    // Redirect to CAS login with proper service parameter
                    // This ensures CAS redirects back to the home page with a ticket,
                    // rather than to whatever resource triggered the 401
                    const serviceUrl = window.location.origin + '/workspace/j_spring_cas_security_check';
                    window.location.href = '/cas/login?service=' + encodeURIComponent(serviceUrl);
                }
                return throwError(() => error); // Re-throw the error for other handlers
            })
        );
    }
}
